import { render } from "./UpdateFeesParcel.vue?vue&type=template&id=14f99614&ts=true"
import script from "./UpdateFeesParcel.vue?vue&type=script&lang=ts"
export * from "./UpdateFeesParcel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__